import React from "react";

interface ImageSelectorProps {
  selectedImage: string | null;
  onChange: (image: string) => void;
}

export const ImageSelector: React.FC<ImageSelectorProps> = ({ selectedImage, onChange }) => {
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => onChange(reader.result as string);
    reader.readAsDataURL(file);
  };

  return (
    <label className="flex justify-stretch w-full h-full cursor-pointer">
      {selectedImage ? (
        <img src={selectedImage} alt="Selected" className="h-full w-full object-cover" />
      ) : (
        <span className="grid place-items-center w-full bg-purple-700 text-white text-xs font-bold">
          UPLOAD
        </span>
      )}
      <input type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
    </label>
  );
};
